<template>
<v-container fluid fill-height>
    <v-layout justify-center>
        <v-responsive max-width="1440px" width="100%">

            <v-row class="mt-8" justify="center" align="center">
                <v-col cols="auto" class="pt-0 pb-0 headline text-start">상품권 목록</v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto" class="pt-0 pb-0">
                    <v-btn class="ma-2" color="secondary" rounded @click="showSearch = !showSearch"><v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터</v-btn>
                </v-col>
            </v-row>

            <v-expand-transition>
                <v-card v-show="showSearch" class="elevation-1 mx-auto">
                    <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                    <v-card-text class="py-0">
                        <v-row>
                            <v-col cols="12" md="3" class="py-0">
                                <v-select v-model="filter.category" :items="categories" item-text="name" item-value="code" label="카테고리" placeholder=" " hide-details></v-select>
                            </v-col>
                            <v-col cols="12" md="3" class="py-0 mt-4 mt-md-0">
                                <v-select v-model="filter.platform" :items="platforms" item-text="text" item-value="value" label="제공업체" placeholder=" " hide-details/>
                            </v-col>
                            <v-col cols="12" md="3" class="py-0 mt-4 mt-md-0">
                                <v-select v-model="filter.mode" :items="modes" item-text="text" item-value="value" label="구분" placeholder=" " hide-details/>
                            </v-col>
                            <v-col cols="12" md="3" class="py-0 mt-4 mt-md-0">
                                <v-select v-model="filter.isApi" :items="apis" item-text="text" item-value="value" label="api여부" placeholder=" " hide-details/>
                            </v-col>
                        </v-row>
                        <v-row class="mt-6" align="center">
                            <v-col cols="12" sm="3" class="py-0">
                                <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" placeholder=" " hide-details @input="filter.searchValue = null"></v-select>
                            </v-col>
                            <v-col cols="12" sm="3" class="py-0">
                                <v-text-field v-model="filter.searchValue" label="검색어" placeholder=" " hide-details :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true)"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" rounded text @click="page = 1; search(true);"><v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색</v-btn>
                    </v-card-actions>
                </v-card>
            </v-expand-transition>

            <v-row class="mt-4" center="end">
                <v-col cols="auto" class="mr-0">
                    <v-text-field v-model="stock" type="number" prefix="선택한 상품권 재고" suffix="개로 " filled dense hide-details class="d-inline-block"/>
                    <v-btn color="white" class="primary--text" @click="changeStock">변경</v-btn>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto">
                    <v-btn color="white" class="green--text px-2 ml-1" @click="excel">
                        <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>엑셀다운로드
                    </v-btn>
                </v-col>
            </v-row>
            <v-data-table v-model="selected" show-select :loading="loading" :headers="giftcardsHeaders" :items="giftcards" item-key="_id" disable-sort disable-pagination hide-default-footer class="elevation-1">
                <template v-slot:item.no="{item}">
                    {{ (page - 1) * limit + giftcards.indexOf(item) + 1 }}
                </template>
                <template v-slot:item.giftcard="{item}">
                    <v-row align="center">
                        <v-col md="auto" class="py-0">
                            <v-img v-if="item.thumb" :src="item.thumb" contain max-width="96" max-height="96"></v-img>
                            <v-responsive v-else width="96" height="96">
                                <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                    <v-icon>mdi-image</v-icon>
                                </v-row>
                            </v-responsive>
                        </v-col>
                        <v-col>
                            <div class="text-start">{{ item.name }}</div>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:item.faceamt="{item}">
                    {{ item.faceamt.format() }}
                </template>
                <template v-slot:item.isApi="{item}">
                    <v-switch v-model="item.isApi" hide-details class="pa-0 ma-0 d-inline-block" color="primary" @change="update({ _id: item._id, platform: item.platform ,isApi: item.isApi })"/>
                </template>
                <template v-slot:item.stock="{item}">
                    {{ item.stock.format() }}
                </template>
                <template v-slot:item.commission="{item}">
                    <div>normal: {{ item.normalCommission }}%</div>
                    <div>vip: {{ item.vipCommission }}%</div>
                    <div>vvip: {{ item.vvipCommission }}%</div>
                </template>
                <template v-slot:item.enabled="{item}">
                    <div v-if="item.unknownEnabled">비회원</div>
                    <div v-if="item.normalEnabled">normal</div>
                    <div v-if="item.vipEnabled">　vip</div>
                    <div v-if="item.vvipEnabled">vvip</div>
                </template>
                <template v-slot:item.actions="{item}">
                    <v-icon small @click="edit(item)" title="수정">mdi-pencil</v-icon>
                    <v-icon small @click="copy(item)" title="복사" class="ml-4">mdi-content-copy</v-icon>
                    <v-icon small @click="remove(item)" title="삭제" class="ml-4">mdi-delete</v-icon>
                </template>
            </v-data-table>
            <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="mt-4 mb-12" @input="search"></v-pagination>

            <v-btn bottom color="accent" fab fixed right @click="create">
                <v-icon>mdi-pencil</v-icon>
            </v-btn>

        </v-responsive>
    </v-layout>
</v-container>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import download from "downloadjs";
import { mdiMicrosoftExcel } from "@mdi/js";
import CategorySelect from '@/components/console/shop/categories/category-select.vue';

export default {
    components: {
        CategorySelect,
    },
    mounted(){
        this.init();
    },
    data(){
        return {
            mdiMicrosoftExcel,
            ///////////////////////////////////////////////
            // 검색필터
            ///////////////////////////////////////////////
            showSearch: true,

            stock: null,
            category: null,
            filter: {
                category: this.$route.query.category || null,
                platform: this.$route.query.platform || null,
                mode: this.$route.query.mode || null,
                isApi: this.$route.query.isApi || null,

                name: this.$route.query.name || null,
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null
            },

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "제품명", value: "name.ko" },
                { text: "기업명", value: "seller.name.ko" },
            ],

            categories: [],

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,
            loading: true,

            selected: [],
            giftcards: [],
            giftcardsHeaders: [
            { text: 'no', align: 'center', width: 80, value: 'no' },
            { text: '상품권', align: 'center', width: 250, value: 'giftcard' },
            { text: '권종', align: 'center', width: 80, value: 'faceamt' },
            { text: '재고수량', align: 'center', width: 80,  value: 'stock' },
            { text: '구분(모바일/지류)', align: 'center', width: 100, value: 'mode' },
            { text: '제공업체', align: 'center', width: 100, value: 'platform' },
            { text: '과금률', align: 'center', width: 110, value: 'commission' },
            { text: '진열여부', align: 'center', width: 80, value: 'enabled' },
            { text: 'api여부', align: 'center', width: 80, value: 'isApi' },
            { text: '정렬순서', align: 'center', width: 80, value: 'sequence' },
            { text: 'Actions', width: 100, align: 'center', value: 'actions' }
            ],

            platforms: [
                { text: ":: 전체 ::", value: null },
                { text: "갤럭시아", value: "galaxia" },
                { text: "페이즈", value: "pays" },
                { text: "다날", value: "danal" },
                { text: "컬쳐랜드", value: "cultureland" },
                { text: "한국문화진흥", value: "cultureland2" },
                { text: "S-OIL", value: "soil" },
            ],

            modes: [
                { text: ":: 전체 ::", value: null },
                { text: "모바일", value: "mobile" },
                { text: "지류", value: "paper" },
            ],

            apis: [
                { text: ":: 전체 ::", value: null },
                { text: "사용", value: "true" },
                { text: "미사용", value: "false" },
            ],
        };
    },
    methods: {
        download,
        async init(){
            var { categories } = await api.console.shop.categories.gets({ params: { depth: 1 }});
            this.categories = [{ name: ":: 전체 ::", code: null }, ...categories];

            if(this.filter._category){
                var { category } = await api.console.shop.categories.get({ _id: this.filter._category });
                this.category = category;
            }

            this.search();
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            this.loading = true;
            this.giftcards = [];
            var { summary, giftcards } = await api.console.shop.giftcards.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.loading = false;
            this.giftcards = giftcards;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        create(){
            this.$router.push(`${this.$route.path}/create`);
        },
        copy(giftcard){
            this.$router.push(`${this.$route.path}/copy?_giftcard=${giftcard._id}`);
        },
        edit(giftcard){
            this.$router.push(`${this.$route.path}/${giftcard._id}`);
        },

        async update(gitfcard){
            await api.console.shop.giftcards.put(gitfcard);
        },

        async excel(){
            var { giftcards } = await api.console.shop.giftcards.gets({
                headers: {
                    limit: 0
                },
                params: this.filter
            });

            var rows = [];
            giftcards.forEach((giftcard) => {
                let category = giftcard._category ? this.categories.find(({ _id, children }) => _id == giftcard._category || children.find(({ _id }) => _id == giftcard._category) ) : null;
                let subCategory = giftcard._category ? category.children.find(({ _id }) => _id == giftcard._category) : null;

                rows.push({
                    "no": giftcards.indexOf(giftcard) + 1,
                    "진열순서": giftcard.sequence,
                    "상품권": giftcard.name,
                    "권종": giftcard.faceamt.format(),
                    "재고수량": giftcard.stock,
                    "구분": giftcard.mode,
                    "제공업체": giftcard.platform,
                    "과금률(normal)": `${giftcard.normalCommission}%`,
                    "과금률(vip)": `${giftcard.vipCommission}%`,
                    "과금률(vvip)": `${giftcard.vvipCommission}%`,
                    "진열여부(비회원)": giftcard.unknownEnabled ? "표시" : "-",
                    "진열여부(normal)": giftcard.unknownEnabled ? "표시" : "-",
                    "진열여부(vip)": giftcard.unknownEnabled ? "표시" : "-",
                    "진열여부(vvip)": giftcard.unknownEnabled ? "표시" : "-",
                });
            });

            var workbook = new XLSX.utils.book_new();
            var worksheet = XLSX.utils.json_to_sheet(rows);

            XLSX.utils.book_append_sheet(workbook, worksheet, "new");
            XLSX.writeFile(workbook, "상품권 목록.xlsx");
        },

        async save(giftcard){
            await api.console.shop.giftcards.put(giftcard);
            await this.search();
        },

        async changeStock(){
            try{
                if(!this.selected.length) throw new Error("상품권을 선택해주세요");
                if(confirm("변경하시겠습니까?")){
                    for(let giftcard of this.selected){
                        await api.console.shop.giftcards.put({ _id: giftcard._id, stock: this.stock, platform: giftcard.platform });
                    }
                    alert("수정되었습니다");
                }
            }
            catch(error){
                alert(error.message);
            }
        },

        async remove(giftcard){
            if(confirm("해당 상품을 삭제하시겠습니까?")){
                await api.console.shop.giftcards.delete(giftcard);
                alert("삭제되었습니다");
                await this.search();
            }
        },
    }
}
</script>